"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_soho__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "341b78e2-5d02-4119-8b11-f300daef6410",
    x1: 91.27,
    y1: 120.82,
    x2: 104.79,
    y2: 134.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "98969cfd-9e9b-4e20-bcd7-955061076684",
    "data-name": "SoHo_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,167.92l9.78-19.53A8,8,0,0,1,76.94,144h38.17a8,8,0,0,1,7.16,4.43L132,167.92",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 112.56,
    x2: 96,
    y2: 168,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 166,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.94,146a4,4,0,0,0-3.58,2.21l-9.78,19.53-6.35-3.18-.8,1.6,7.15,3.58,9.78-19.53A4,4,0,0,1,76.94,148H92v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.41,167.7l-9.72-19.52a4,4,0,0,0-3.58-2.22H100v2h15.11a4,4,0,0,1,3.58,2.22l9.72,19.52,7.16-3.57-.8-1.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,76V99.92a8,8,0,0,0,8,8H66.83",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,76V99.92a8,8,0,0,1-8,8H125.19",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.83,109.92H52a12,12,0,0,1-12-12v2a12,12,0,0,0,12,12H66.83a4,4,0,0,0,3.86-5A4,4,0,0,1,66.83,109.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,109.92H125.19a4,4,0,0,1-3.86-3,4,4,0,0,0,3.86,5H140a12,12,0,0,0,12-12v-2A12,12,0,0,1,140,109.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80,15.83h32a16,16,0,0,1,16,16v68a0,0,0,0,1,0,0H64a0,0,0,0,1,0,0v-68A16,16,0,0,1,80,15.83Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 96,
    width: 88,
    height: 24,
    rx: 8,
    ry: 8,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 96,
    width: 88,
    height: 24,
    rx: 8,
    ry: 8,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,118H60a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8v-2A8,8,0,0,1,132,118Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.01,
    cy: 167.92,
    r: 8,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,173.92a8,8,0,0,1-7.93-7,8,8,0,1,0,15.86,0A8,8,0,0,1,60,173.92Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 167.92,
    r: 8,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,173.92a8,8,0,0,1-7.93-7,8,8,0,1,0,15.86,0A8,8,0,0,1,96,173.92Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 167.92,
    r: 8,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 167.92,
    r: 8,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,173.92a8,8,0,0,1-7.93-7,8,8,0,1,0,15.86,0A8,8,0,0,1,132,173.92Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.05 139.08 92.02 131.05 92.02 120.06 100.02 120.08 100.02 130.57 100.05 139.08",
    opacity: 0.2,
    fill: "url(#341b78e2-5d02-4119-8b11-f300daef6410)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "soho-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "f1a6355c-097f-42ba-94cd-abd9567453a5",
    "data-name": "SoHo_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "e847a616-5d7f-4dae-9ff3-09c19880e86e",
    "data-name": "SoHo_ic_hi",
    width: 192,
    height: 192,
    xlinkHref: "#98969cfd-9e9b-4e20-bcd7-955061076684"
  })));
}

var _default = ic_soho__dark;
exports.default = _default;